import React from "react";
import {
  MdSearch,
  MdShoppingCart,
  MdFilterList,
  MdStore,
  MdList,
  MdLocalPhone,
  MdHistory,
  MdExitToApp,
  MdAccountCircle,
  MdLogin,
  MdHome,
  MdMenu,
} from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { ProductList } from "../productCard";
import { ServiceList } from "../serviceList";
import { AWS_URL } from "../../../services/http.service";
import { adjustColor } from "../../../helpers/csshelper";

export {
  MdSearch,
  MdShoppingCart,
  MdFilterList,
  MdStore,
  MdList,
  MdLocalPhone,
  MdHistory,
  MdExitToApp,
  MdAccountCircle,
  MdLogin,
  MdHome,
  MdMenu,
  FaWhatsapp,
  FaHeart,
  ProductList,
  ServiceList,
  AWS_URL,
  adjustColor,
};

// Theme images with guaranteed working URLs
export const THEME_IMAGES = {
  dawn: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=1200&q=85",
  sense:
    "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=85",
  craft:
    "https://images.unsplash.com/photo-1528674839572-8b3c63b5e7e6?w=1200&q=85",
  elysian:
    "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=85",

  aura: "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/724b3e70-33c5-4d68-9bc5-38631edd2f2f_aura.jpg",
  velora:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/4598d58d-4f56-4916-b93a-d1c1401bee4b_velora.jpg",
  orbit:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/76d80a10-f428-498e-a615-dd7b06cba415_3.jpg",
  vogue:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/1ffad972-856d-423f-972f-4259bea1141b_vouge.avif",
  royalcouture:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/18ab0121-1b8b-4c43-9045-563881abc22a_couture.avif",

  fresh:
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&q=85",
  empire:
    "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1200&q=85",
  bloom:
    "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=1200&q=85",
  circuit:
    "https://images.unsplash.com/photo-1498049794561-7780e7231661?w=1200&q=85",
  slate:
    "https://images.unsplash.com/photo-1486475554424-2fa50cd59f18?w=1200&q=85",
  grove:
    "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=1200&q=85",
  tide: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=85",
  aurora:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=85",
  spice:
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=85",
  regal:
    "https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=1200&q=85",
  meadow:
    "https://images.unsplash.com/photo-1463320726281-696a485928c7?w=1200&q=85",
  pantry:
    "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200&q=85",
  atelier:
    "https://images.unsplash.com/photo-1445205170230-053b83016050?w=1200&q=85",
  remedy:
    "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1200&q=85",
  forge:
    "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=1200&q=85",
  ovenly:
    "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?w=1200&q=85",
  harvest:
    "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1200&q=85",
  midnight:
    "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=1200&q=85",
  ember:
    "https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=1200&q=85",
  mint: "https://images.unsplash.com/photo-1489269637500-aa0e75768394?w=1200&q=85",
  lunar:
    "https://images.unsplash.com/photo-1532767153582-b1a0e5145009?w=1200&q=85",
  solar:
    "https://images.unsplash.com/photo-1508780709619-79562169bc64?w=1200&q=85",
  nebula:
    "https://images.unsplash.com/photo-1541701494587-cb58502866ab?w=1200&q=85",
  willow:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=85",
  stone:
    "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1200&q=85",
  coral:
    "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&q=85",
  indigo:
    "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=85",
  amber:
    "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?w=1200&q=85",
  arctic:
    "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=85",

  ironforge:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/df1f4d0c-9a7c-40da-9c86-01d65aba6d6f_a1.jpg",
  hardwarepro:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/a8415eec-007c-42cb-a0e0-1084d885b373_h1.jpg",
  stationerypro:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/624be9de-8796-47d6-bf3e-d5cbb813dc92_Premium_Notebook_(Set_of_5).jpg",
  nexus:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/4177daf5-dab9-4843-90a2-88664b699f9e_nexus.jpg",
  quantum:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/76950b04-9978-4568-9608-944253ef4388_quantum.jpg",
  apple:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/c7dcd667-992c-497b-9b67-c94c76410608_apple.jpg",
  samsung:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/c2f61f2e-e768-43b2-b883-fc1639487852_samsung.jpg",
  luxeglow:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/f048525b-adfc-40e8-8a1c-2c78dec4e5cd_luxeglow.jpg",
  glowaura:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/59ccff16-fcd8-4b1e-9e9f-abc2095e1cd5_glowaura.jpg",
  floranectar:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/bc84e76f-1ebc-4848-8a68-f9a9cc67e7f9_floracenter.jpg",
  silkyclay:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/92acf243-ca9c-445b-965c-552374bb4f5a_silkyclay.jpg",
  vitality:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/217fce67-62ab-4ec5-9cf0-8f8175bb09c8_vitality.jpg",
  breeze:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/1ef54a28-273a-49f5-a5bd-7c3c3a3d2582_breez.jpg",
  urban:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/909f3558-56d0-4503-8f42-b7ddc39f305d_urban.jpg",
  eclipse:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/b63d994c-fff2-4a19-affd-a797dda9c018_eclips.jpg",
  mobitech:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/779b699c-3677-4cfb-b8bb-4b95346caec0_mobitech.jpg",
  pixel:
    "https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=1200&q=85",
  oneplus:
    "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=1200&q=85",

  ecofarm:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/9e8a94eb-a37b-413f-884c-0426b057ac94_eco1.jpg",
  farmfresh:
    "https://s3.us-east-1.amazonaws.com/dukanbuddy-normal/blogs/698aeaf4-8dfb-45b8-b7de-488a99d8331c_farm1.jpg",

  medicare:
    "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=800&q=80",
  medicareplus:
    "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80",
    apexmanufacturing:"https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80",
    enchantedgifts:"https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=800&q=80",
};

export const THEME_LAYOUT_TYPES = {
  dawn: "dawn",
  sense: "sense",
  craft: "craft",
  fresh: "fresh",
  grove: "grove",
  bloom: "bloom",
  empire: "empire",
  aurora: "aurora",
  spice: "spice",
  circuit: "circuit",
  tide: "tide",
  slate: "slate",
  regal: "empire",
  meadow: "grove",
  pantry: "pantry",
  atelier: "sense",
  remedy: "dawn",
  forge: "circuit",
  ovenly: "spice",
  harvest: "grove",
  midnight: "midnight",
  ember: "ember",
  mint: "mint",
  lunar: "lunar",
  solar: "solar",
  nebula: "nebula",
  willow: "willow",
  stone: "stone",
  coral: "coral",
  indigo: "indigo",
  amber: "amber",
  elysian: "elysian",
  arctic: "arctic",
  aura: "aura",
  velora: "velora",
  orbit: "orbit",
  vogue: "vogue",
  royalcouture: "royalcouture",
  brewblend: "brewblend",
  goldenharvest: "goldenharvest",
  freshpantry: "freshpantry",
  bloomflora: "bloomflora",
  luxesalon: "luxesalon",
  ironforge: "ironforge",
  agriharvest: "agriharvest",
  hardwarepro: "hardwarepro",
  stationerypro: "stationerypro",
  nexus: "nexus",
  quantum: "slate",
  apple: "apple",
  samsung: "samsung",
  luxeglow: "luxeglow",
  glowaura: "glowaura",
  floranectar: "floranectar",
  silkyclay: "silkyclay",
  vitality: "vitality",
  breeze: "breeze",
  urban: "urban",
  eclipse: "lunar",
  mobitech: "mobitech",
  pixel: "pixel",
  oneplus: "oneplus",
  ecofarm: "ecofarm",
  farmfresh: "farmfresh",
  medicare: "medicare",
  medicareplus: "medicareplus",
  apexmanufacturing: "apexmanufacturing",
  enchantedgifts: "enchantedgifts",
  vortex: "vortex",
  studionoir: "studionoir",
  custom: "custom",
};

export function getLayoutType(themeId) {
  return THEME_LAYOUT_TYPES[themeId] || "dawn";
}

export function isDarkTheme(theme) {
  if (!theme) return false;
  const color = theme.backgroundColor;
  if (!color) return false;
  let hex = color.replace("#", "");
  if (hex.length === 3)
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}

// Check if a raw hex color is too bright (luminance > 0.7) for dark backgrounds
export function isLightColor(color) {
  if (!color) return false;
  let hex = color.replace("#", "");
  if (hex.length === 3)
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.7;
}

export function getAddress(storeInfo) {
  if (!storeInfo) return "";
  if (typeof storeInfo.address === "object") {
    return [
      storeInfo.address.street,
      storeInfo.address.city,
      storeInfo.address.state,
    ]
      .filter(Boolean)
      .join(", ");
  }
  return storeInfo.address || "";
}

export function getBtnRadius(theme) {
  return theme?.buttonStyle === "pill"
    ? "9999px"
    : theme?.buttonStyle === "rounded"
      ? "8px"
      : "4px";
}

export function getHeroContent(p, defaults = {}) {
  const theme = p.storeTheme || {};
  const text = p.storefrontText || {};
  const fallbackSubtitle =
    p.storeDescription ||
    p.storeInfo?.businessDescription ||
    p.overviewContent ||
    defaults.subtitle ||
    "";

  return {
    eyebrow:
      theme.heroEyebrow ||
      defaults.eyebrow ||
      theme.themeName ||
      "Featured Store",
    title:
      theme.heroTitle ||
      p.storeInfo?.businessName ||
      defaults.title ||
      "Your Store",
    subtitle: theme.heroSubtitle || fallbackSubtitle,
    primaryCta:
      theme.primaryCtaText || text.shopNow || defaults.primaryCta || "Shop Now",
    secondaryCta:
      theme.secondaryCtaText ||
      text.learnMore ||
      defaults.secondaryCta ||
      "Learn More",
  };
}

export function InlineEditableText({
  p,
  field,
  value,
  className = "",
  style = {},
  children,
}) {
  const isEditing = p.previewEditMode && p.activeEditField === field;
  const currentValue = p.storeTheme?.[field] ?? value ?? "";

  const handleActivate = (event) => {
    event.stopPropagation();
    if (!p.previewEditMode) return;
    if (typeof p.onActivateField === "function") {
      p.onActivateField(field);
    }
  };

  const handleChange = (event) => {
    if (typeof p.onPreviewTextChange === "function") {
      p.onPreviewTextChange(field, event.target.value);
    }
  };

  const handleBlur = () => {
    if (typeof p.onDeactivateField === "function") {
      p.onDeactivateField();
    }
  };

  if (isEditing) {
    const inputClass =
      "w-full rounded-2xl border border-slate-200 bg-white/90 px-3 py-2 text-sm text-slate-900 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100";
    const multiline =
      field.toLowerCase().includes("subtitle") ||
      field.toLowerCase().includes("description") ||
      field.toLowerCase().includes("overview");

    return multiline ? (
      <textarea
        autoFocus
        rows={4}
        value={currentValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={(event) => event.stopPropagation()}
        className={inputClass}
        style={{ whiteSpace: "pre-wrap", ...style }}
      />
    ) : (
      <input
        autoFocus
        type="text"
        value={currentValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={(event) => event.stopPropagation()}
        className={inputClass}
        style={{ whiteSpace: "pre-wrap", ...style }}
      />
    );
  }

  return (
    <span
      className={`${className} cursor-pointer`}
      style={{ whiteSpace: "pre-wrap", ...style }}
      onClick={handleActivate}
      title={p.previewEditMode ? "Edit text" : "Click to edit"}
    >
      {children}
    </span>
  );
}

export function InlineEditableImage({
  p,
  field = "themePreviewImage",
  className = "",
  style = {},
  children,
}) {
  const handleActivate = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!p.previewEditMode) return;
    if (typeof p.onImageFieldClick === "function") {
      p.onImageFieldClick(field, event);
      return;
    }
    if (typeof p.onActivateField === "function") {
      p.onActivateField(field);
    }
  };

  return (
    <div
      className={`relative ${className} cursor-pointer`}
      style={style}
      onClick={handleActivate}
      title={p.previewEditMode ? "Upload image" : "Click to edit image"}
    >
      {children}
    </div>
  );
}

export function getTabLabel(p, key, variant = "default") {
  const text = p.storefrontText || {};

  if (key === "products") {
    if (variant === "shop") return text.shop || text.products || "Shop";
    if (variant === "menu") return text.menu || text.products || "Menu";
    return text.products || "Products";
  }

  if (key === "services") return text.services || "Services";
  if (key === "details")
    return variant === "store-info"
      ? text.storeInfo || "Store Info"
      : text.about || "About";

  return key;
}

// FIXED HeroImage component - Prioritize storeTheme.themePreviewImage
const normalizeImageUrl = (value) => {
  if (!value) return "";
  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  )
    return value;
  if (value.startsWith("/")) return `${window.location.origin}${value}`;
  if (value.startsWith("uploads/") || value.startsWith("images/"))
    return `${AWS_URL}${value}`;
  return value;
};

export function HeroImage({
  p,
  themeId: overrideId,
  className = "",
  field,
  children,
}) {
  const showStoreBanner = p.shouldUseStoreBanner;
  const storeBanner =
    showStoreBanner && typeof p.getBannerUrl === "function"
      ? p.getBannerUrl()
      : null;
  const tid =
    overrideId ||
    p.resolvedThemeId ||
    p.storeTheme?.themeId ||
    p.storeTheme?.id ||
    "";

  const targetField = field || (tid ? `${tid}HeroImage` : "themePreviewImage");

  // CRITICAL FIX: Prioritize storeTheme.themePreviewImage first
  let src = null;

  // Priority 1: Store banner if enabled and exists
  if (showStoreBanner && storeBanner) {
    src = storeBanner;
  }
  // Priority 1.5: Custom field for this theme if it exists in storeTheme or themeText
  else if (p.storeTheme?.[targetField]) {
    src = p.storeTheme[targetField];
  }
  else if (p.themeText?.[targetField]) {
    src = p.themeText[targetField];
  }
  // Priority 2: Direct from storeTheme.themePreviewImage (MOST IMPORTANT)
  else if (p.storeTheme?.themePreviewImage) {
    src = p.storeTheme.themePreviewImage;
  }
  // Priority 3: From getThemePreviewImage function
  else if (typeof p.getThemePreviewImage === "function") {
    const previewImage = p.getThemePreviewImage();
    if (previewImage) {
      src = previewImage;
    }
  }
  // Priority 4: Dynamic fallback to first available product image in store catalog
  else if (
    p.filteredProducts?.length > 0 &&
    p.filteredProducts.find(
      (prod) => prod.productImage || prod.thumbnail || prod.image,
    )
  ) {
    const firstProduct = p.filteredProducts.find(
      (prod) => prod.productImage || prod.thumbnail || prod.image,
    );
    const prodImg =
      firstProduct.productImage || firstProduct.thumbnail || firstProduct.image;
    src = prodImg.startsWith("http") ? prodImg : AWS_URL + prodImg;
    console.log("HeroImage using first product image:", src);
  }
  // Priority 5: Theme image from storeTheme
  else if (p.storeTheme?.image) {
    src = p.storeTheme.image;
    console.log("HeroImage using storeTheme.image:", src);
  }
  // Priority 5: Fallback from THEME_IMAGES by theme ID
  else if (tid && THEME_IMAGES[tid]) {
    src = THEME_IMAGES[tid];
    console.log("HeroImage using THEME_IMAGES fallback:", src);
  }
  // Priority 6: Final fallback to dawn theme image
  else {
    src =
      THEME_IMAGES.dawn ||
      "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=1200&q=85";
    console.log("HeroImage using final fallback:", src);
  }

  const normalizedSrc = normalizeImageUrl(src);
  const isColorBanner = showStoreBanner && p.storeBanner?.type === "color";
  const T = p.storeTheme || {};

  const isEditable = typeof p.onActivateField === "function";
  const handleClick = (event) => {
    if (!isEditable) return;
    
    // Prevent click on interactive elements from bubbling
    const isInteractive = event.target.closest('button, a, input, textarea, [role="button"]');
    if (isInteractive && isInteractive !== event.currentTarget) return;

    // Prevent click on editable texts from bubbling
    if (event.target.closest('.inline-editable-text') || event.target.closest('[title="Edit text"]')) return;

    event.stopPropagation();
    if (typeof p.onImageFieldClick === "function") {
      p.onImageFieldClick(targetField, event);
    } else if (typeof p.onActivateField === "function") {
      p.onActivateField(targetField);
    }
  };

  return (
    <div
      className={`relative overflow-hidden ${className} ${isEditable ? "cursor-pointer" : ""}`}
      onClick={handleClick}
      role={isEditable ? "button" : undefined}
      tabIndex={isEditable ? 0 : undefined}
      title={p.previewEditMode ? "Upload image" : "Click to edit image"}
    >
      {isColorBanner ? (
        <div
          className="h-full w-full"
          style={{
            backgroundColor: p.storeBanner.color || T.primaryColor || "#4f46e5",
          }}
        />
      ) : normalizedSrc ? (
        <img
          key={normalizedSrc}
          src={normalizedSrc}
          alt="Store hero banner"
          className="h-full w-full object-cover object-center"
          onError={(e) => {
            console.error("HeroImage failed to load:", normalizedSrc);
            e.target.src = THEME_IMAGES.dawn;
            e.target.onerror = null;
          }}
          onLoad={() =>
            console.log("HeroImage loaded successfully:", normalizedSrc)
          }
        />
      ) : (
        <div
          className="h-full w-full"
          style={{
            background: `linear-gradient(135deg, ${T.primaryColor || "#4f46e5"} 0%, ${T.secondaryColor || "#10b981"} 100%)`,
          }}
        />
      )}
      {children}
    </div>
  );
}

export function StoreLogo({
  storeInfo,
  size = "h-12 w-12",
  border = "border-2 border-white",
}) {
  return (
    <div
      className={`${size} rounded-full ${border} bg-white shadow-md overflow-hidden flex items-center justify-center flex-shrink-0`}
    >
      {storeInfo?.businesslogo ? (
        <img
          src={AWS_URL + storeInfo.businesslogo}
          alt="Store Logo"
          className="h-full w-full object-cover"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.querySelector(
              ".fallback-logo",
            ).style.display = "flex";
          }}
        />
      ) : null}
      <span
        className="text-gray-500 font-bold fallback-logo"
        style={{ display: storeInfo?.businesslogo ? "none" : "flex" }}
      >
        {storeInfo?.businessName?.charAt(0)?.toUpperCase() || "S"}
      </span>
    </div>
  );
}

export function SearchBar({
  searchQuery,
  setSearchQuery,
  theme,
  dark = false,
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <input
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder={theme?.searchPlaceholder || "Search items..."}
        className={`w-full py-2 pl-10 pr-4 rounded-xl text-sm border focus:outline-none ${
          dark
            ? "bg-gray-900 border-gray-700 text-gray-200 placeholder-gray-500"
            : "bg-white border-gray-200 text-gray-700 placeholder-gray-400"
        }`}
        style={{ fontFamily: theme?.fontFamily || "Inter" }}
      />
      <MdSearch
        className={`absolute left-3 top-2.5 text-lg ${dark ? "text-gray-500" : "text-gray-400"}`}
      />
    </div>
  );
}

export function TopControls({
  search,
  setSearch,
  selectedCategory,
  setSelectedCategory,
  categories = [],
  store = {},
  showCategoryInSearch = true,
  shellClassName = "",
  searchClassName = "",
  selectClassName = "",
  rightActionsClassName = "",
  iconButtonClassName = "",
}) {
  const text = store.storefrontText || {};
  return (
    <div className={`rounded-2xl border p-3 sm:p-4 ${shellClassName}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="relative flex-1">
          <MdSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-gray-500" />
          <input
            value={search || ""}
            onChange={(e) => setSearch?.(e.target.value)}
            placeholder={text.searchProducts || "Search products"}
            className={`w-full rounded-xl border px-10 py-2.5 text-sm outline-none transition focus:ring-2 ${searchClassName}`}
          />
        </div>

        {showCategoryInSearch && categories.length > 0 && (
          <select
            value={selectedCategory || ""}
            onChange={(e) => setSelectedCategory?.(e.target.value)}
            className={`rounded-xl border px-3 py-2.5 text-sm outline-none transition focus:ring-2 ${selectClassName}`}
          >
            <option value="">All Categories</option>
            {categories.map((category) => {
              const value =
                typeof category === "string" ? category : category.value;
              const label =
                typeof category === "string" ? category : category.label;
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              );
            })}
          </select>
        )}

        <div className={`flex items-center gap-2 ${rightActionsClassName}`}>
          <button
            type="button"
            onClick={store.handleWishlist}
            className={`relative flex h-10 w-10 items-center justify-center rounded-xl border transition ${iconButtonClassName}`}
            title={text.wishlist || "Wishlist"}
          >
            <FaHeart className="text-sm" />
            {(store.wishlistCount || 0) > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
                {store.wishlistCount}
              </span>
            )}
          </button>
          <button
            type="button"
            onClick={store.handleCart}
            className={`relative flex h-10 w-10 items-center justify-center rounded-xl border transition ${iconButtonClassName}`}
            title={text.cart || "Cart"}
          >
            <MdShoppingCart className="text-lg" />
            {(store.cartCount || 0) > 0 && (
              <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-emerald-600 text-[10px] font-bold text-white">
                {store.cartCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export function CartBtn({ p, dark = false }) {
  const count = p.cart?.reduce((s, i) => s + (i.cartQuantity || 1), 0) || 0;

  const theme = p.storeTheme || {};
  const isLunar =
    theme.themeId === "lunar" || theme.themeName?.toLowerCase() === "lunar";

  // When on a dark theme, swap too-bright button colors (like white) to black
  let btnBg = theme?.buttonColor || "#4f46e5";
  let btnText = "#ffffff";
  if (isLunar) {
    btnBg = "#000000";
    btnText = "#ffffff";
  } else if (dark && isDarkTheme(theme)) {
    const isButtonBright = isLightColor(btnBg);
    if (isButtonBright) {
      btnBg = "#111111";
      btnText = "#ffffff";
    }
  }

  return (
    <button
      onClick={p.handleOpenCart}
      title={p.storefrontText?.cart || "Cart"}
      className={`relative px-3 py-2 rounded-xl flex items-center gap-1.5`}
      style={{
        backgroundColor: btnBg,
        color: btnText,
        border: isLunar ? "1px solid rgba(255, 255, 255, 0.15)" : "none",
        borderRadius: getBtnRadius(theme),
      }}
    >
      <MdShoppingCart className="text-xl" />
      <span className="hidden sm:inline text-sm font-semibold">
        {p.storefrontText?.cart || "Cart"}
      </span>
      {count > 0 && (
        <span className="absolute -top-1.5 -right-1.5 h-5 w-5 text-[10px] rounded-full flex items-center justify-center bg-white text-slate-700 border border-slate-200">
          {count}
        </span>
      )}
    </button>
  );
}

export function EmptyState({
  query,
  onClear,
  theme,
  text = {},
  type = "products",
}) {
  const noMatchText =
    type === "services"
      ? text.noServicesMatch ||
        theme?.noServicesMatchText ||
        "No services match your search"
      : text.noProductsMatch ||
        theme?.noProductsMatchText ||
        "No products match your search";
  const noAvailableText =
    type === "services"
      ? text.noServicesAvailable ||
        theme?.noServicesAvailableText ||
        "No services available yet"
      : text.noProductsAvailable ||
        theme?.noProductsAvailableText ||
        "No products available yet";

  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-12 text-center">
      <h3 className="text-lg font-semibold text-slate-700">
        {query ? noMatchText : noAvailableText}
      </h3>
      {query && (
        <button
          onClick={onClear}
          className="mt-4 px-4 py-2 rounded-lg text-sm font-semibold text-white"
          style={{
            backgroundColor: theme?.buttonColor || "#4f46e5",
            borderRadius: getBtnRadius(theme),
          }}
        >
          {text.clearSearch || theme?.clearSearchText || "Clear Search"}
        </button>
      )}
    </div>
  );
}

export function BusinessDetails({ p, dark: forceDark = false }) {
  const T = p.storeTheme || {};
  const isThemeDark = isDarkTheme(T);
  const dark = forceDark || isThemeDark;

  return (
    <div
      className={`rounded-3xl overflow-hidden border ${dark ? "bg-gray-900 border-gray-800" : "bg-white border-slate-200"}`}
      style={{ backgroundColor: dark ? undefined : T.backgroundColor }}
    >
      <div
        className={`${dark ? "bg-gray-950" : "bg-slate-50"} p-6 border-b ${dark ? "border-gray-800" : "border-slate-200"}`}
        style={{
          backgroundColor: dark
            ? undefined
            : T.backgroundColor
              ? adjustColor(T.backgroundColor, -5)
              : undefined,
        }}
      >
        <h2
          className={`text-2xl font-bold ${dark ? "text-white" : "text-slate-900"}`}
          style={{ color: dark ? T.headingColor : undefined }}
        >
          {p.storeInfo?.businessName}
        </h2>
        <p
          className={`text-sm mt-1 ${dark ? "text-gray-300" : "text-slate-600"}`}
          style={{ color: dark ? T.textColor : undefined }}
        >
          {getAddress(p.storeInfo)}
        </p>
      </div>
      <div className="p-6 space-y-6">
        <div>
          <p
            className={`mt-3 text-sm leading-relaxed ${dark ? "text-gray-300" : "text-slate-600"}`}
            style={{ color: dark ? T.textColor : undefined }}
          >
            {p.storeDescription ||
              p.storeInfo?.businessDescription ||
              p.overviewContent}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            className={`rounded-xl p-4 border ${dark ? "bg-gray-950 border-gray-800 text-gray-300" : "bg-slate-50 border-slate-200 text-slate-600"}`}
            style={{
              backgroundColor: dark
                ? undefined
                : T.backgroundColor
                  ? adjustColor(T.backgroundColor, -2)
                  : undefined,
              color: dark ? T.textColor : undefined,
            }}
          >
            <p className="font-semibold mb-2">
              {p.storefrontText?.contact || "Contact"}
            </p>
            <p className="text-sm">{p.storeInfo?.phone}</p>
            <p className="text-sm">
              {p.storeInfo?.email ||
                p.storefrontText?.notProvided ||
                "Not provided"}
            </p>
          </div>
          <div
            className={`rounded-xl p-4 border ${dark ? "bg-gray-950 border-gray-800 text-gray-300" : "bg-slate-50 border-slate-200 text-slate-600"}`}
            style={{
              backgroundColor: dark
                ? undefined
                : T.backgroundColor
                  ? adjustColor(T.backgroundColor, -2)
                  : undefined,
              color: dark ? T.textColor : undefined,
            }}
          >
            <p className="font-semibold mb-2">
              {p.storefrontText?.business || "Business"}
            </p>
            <p className="text-sm">
              {p.storefrontText?.businessType || "Business Type"}:{" "}
              {p.storeInfo?.businessCategory || "N/A"}
            </p>
            <p className="text-sm">GST: {p.storeInfo?.gstNumber || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function TabContent({ p, dark: forceDark = false }) {
  const T = p.storeTheme || {};
  const isThemeDark = isDarkTheme(T);
  const dark = forceDark || isThemeDark;

  const renderContent = () => {
    if (p.activeTab === "products") {
      return p.filteredProducts?.length > 0 ? (
        <ProductList
          products={p.filteredProducts}
          onAddToCart={p.handleAddToCart}
          theme={{
            ...T,
            themeId: p.resolvedThemeId,
            productVariant: p.resolvedProductVariant,
          }}
          customerProfile={p.userProfile}
          displayBusinessName={p.displayBusinessName}
          previewMode={Boolean(p.previewMode)}
        />
      ) : (
        <EmptyState
          query={p.searchQuery}
          onClear={() => p.setSearchQuery("")}
          theme={T}
          text={p.storefrontText}
          type="products"
        />
      );
    }

    if (p.activeTab === "services") {
      return p.filteredServices?.length > 0 ? (
        <ServiceList services={p.filteredServices} theme={T} />
      ) : (
        <EmptyState
          query={p.searchQuery}
          onClear={() => p.setSearchQuery("")}
          theme={T}
          text={p.storefrontText}
          type="services"
        />
      );
    }

    return <BusinessDetails p={p} dark={dark} />;
  };

  return (
    <div id="storefront-tabs-content" className="w-full">
      {renderContent()}
    </div>
  );
}

export function StoreFooter({ p, dark: forceDark = false }) {
  const T = p.storeTheme || {};
  const isThemeDark = isDarkTheme(T);
  const dark = forceDark || isThemeDark;

  // NEW: Get Call & WhatsApp settings from props
  const showCallButton = p.showCallButton !== false; // Default to true if not set
  const showWhatsappButton = p.showWhatsappButton !== false;
  const callPhoneNumber = p.callPhoneNumber || p.storeInfo?.phone || "";
  const whatsappNumber = p.whatsappNumber || p.storeInfo?.phone || "";
  const whatsappMessage =
    p.whatsappMessage || "Hi! I am interested in your products.";

  return (
    <footer
      className={`mt-10 border-t py-8 px-4 ${dark ? "bg-black border-gray-800 text-gray-400" : "bg-slate-100 border-slate-200 text-slate-600"}`}
      style={{ backgroundColor: dark ? undefined : T.backgroundColor }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-4">
        <img
          src="https://iconsbucket1.s3.us-east-1.amazonaws.com/logo.png"
          alt="Dukanbuddy"
          className="h-11 w-1/5 rounded-lg"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <div className="flex-1">
          <p
            className={`font-semibold ${dark ? "text-gray-100" : "text-slate-800"}`}
            style={{ color: dark ? T.headingColor : undefined }}
          >
            {p.storeInfo?.businessName}
          </p>
          <p
            className="text-sm opacity-70"
            style={{ color: dark ? T.textColor : undefined }}
          >
            {p.storeInfo?.pincode}, {p.storeInfo?.state}
          </p>
        </div>
        <div className="flex gap-2">
          {showCallButton &&
            callPhoneNumber &&
            (p.previewMode ? (
              <button
                type="button"
                disabled
                className="px-3 py-2 rounded-lg border text-sm cursor-not-allowed opacity-40"
                style={{
                  borderColor: T.primaryColor + "55" || "#cbd5e1",
                  color: dark ? T.textColor : undefined,
                }}
                aria-disabled="true"
              >
                <MdLocalPhone className="inline mr-1" />{" "}
                {p.storefrontText?.callNow || "Call Now"}
              </button>
            ) : (
              <a
                href={`tel:${callPhoneNumber}`}
                className="px-3 py-2 rounded-lg border text-sm"
                style={{
                  borderColor: T.primaryColor + "55" || "#cbd5e1",
                  color: dark ? T.textColor : undefined,
                }}
              >
                <MdLocalPhone className="inline mr-1" />{" "}
                {p.storefrontText?.callNow || "Call Now"}
              </a>
            ))}

          {showWhatsappButton &&
            whatsappNumber &&
            (p.previewMode ? (
              <button
                type="button"
                disabled
                className="px-3 py-2 rounded-lg text-sm text-white cursor-not-allowed opacity-40"
                style={{ backgroundColor: "#25D366" }}
                aria-disabled="true"
              >
                <FaWhatsapp className="inline mr-1" />{" "}
                {p.storefrontText?.whatsapp || "WhatsApp"}
              </button>
            ) : (
              <a
                href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(whatsappMessage)}`}
                className="px-3 py-2 rounded-lg text-sm text-white"
                style={{ backgroundColor: "#25D366" }}
              >
                <FaWhatsapp className="inline mr-1" />{" "}
                {p.storefrontText?.whatsapp || "WhatsApp"}
              </a>
            ))}
        </div>
      </div>
    </footer>
  );
}
